import { useState } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../assets/icons/download.svg"
import WalletStats from "./WalletStats";
import WalletsTable from "./WalletsTable";
import WalletsReports from "./WalletsReports";
import backBtn from "../../assets/icons/arrow_left.svg";
import "../../styles/wallets.css";


const WalletManagement = () => {

	const [showWalletReports, setShowWalletReports] = useState(false);

	return (
		<>
			<div className="component-body">
				<div className="page-title">
					{!showWalletReports && (
						<>
							<h2>Wallets</h2>
							<div className="action-btns">
								<Button className="view-reports" onClick={() => setShowWalletReports(true)}>View Reports</Button>
								<Button>
									<img src={downloadIcon} alt="download" />
									Export
								</Button>
							</div>
						</>
					)}
					{showWalletReports && (
						<>
							<div style={{ display: 'flex', gap: '15px' }}>
								<img src={backBtn} alt="back" onClick={() => setShowWalletReports(false)} style={{ cursor: 'pointer' }} />
								<h2>Wallet Reports</h2>
							</div>
							<Button>
								<img src={downloadIcon} alt="download" />
								Export
							</Button>
						</>
					)}
				</div>
				<div>
					{!showWalletReports && (
						<>
							<WalletStats />
							<WalletsTable />
						</>
					)}
					{showWalletReports && (
						<WalletsReports />
					)}
				</div>
			</div>
		</>
	)
};

export default WalletManagement;